export type Usuari = {
    id: number;
    avatar: string;
    usu: string;
    nom: string;
    cognoms: string;
    email: string;
    gitlab: string;
    curs: string;
    repetidor: boolean;
    afegit: boolean;
    isjavamon: boolean;
    rol: number;
    ide: number;
    avaluacio: number;
}
export const DefaultUsuari: Usuari = {
    "id": 0,
    "usu": "",
    "nom": "",
    "cognoms": "",
    "email": "",
    "gitlab": "",
    "curs": "",
    "repetidor": false,
    "isjavamon": false,
    "afegit": false,
    "rol": 0,
    "ide": 0,
    "avaluacio": 0,
    "avatar": "",
}
